"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoLogoutMixin = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _helper = require("@/services/helper/helper.service");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AUTO_LOGOUT_DATE = 'AUTO_LOGOUT_DATE';

var AutoLogoutMixin = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(AutoLogoutMixin, _Vue);

  var _super = _createSuper(AutoLogoutMixin);

  function AutoLogoutMixin() {
    (0, _classCallCheck2.default)(this, AutoLogoutMixin);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AutoLogoutMixin, [{
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.helper) {
        this.helper = new _helper.Helper();
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      this.checkDate();
    }
  }, {
    key: "checkDate",
    value: function checkDate() {
      var today = (0, _moment.default)(new Date()).format('YYYY-MM-DD');
      var localStorageDate = window.localStorage.getItem(AUTO_LOGOUT_DATE);

      if (this.helper.isUndefined(localStorageDate)) {
        window.localStorage.setItem(AUTO_LOGOUT_DATE, today);
        return;
      }

      if (today !== localStorageDate) {
        window.localStorage.setItem(AUTO_LOGOUT_DATE, today);
        this.$logOutUser();
      }
    }
  }]);
  return AutoLogoutMixin;
}(_vuePropertyDecorator.Vue);

exports.AutoLogoutMixin = AutoLogoutMixin;
(0, _tslib.__decorate)([(0, _vuexClass.Action)('logOutUser', {
  namespace: 'authentication'
})], AutoLogoutMixin.prototype, "$logOutUser", void 0);
exports.AutoLogoutMixin = AutoLogoutMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], AutoLogoutMixin);